module.exports = __webpack_public_path__ + "static/img/areaB_4.5d553e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_4.png
// module id = 1267
// module chunks = 1